import { Component, type ErrorInfo, type ReactNode } from 'react';
import { id } from '@/i18n/id';
import { Button } from '@/components/ui/button';

type Props = { children: ReactNode };
type State = { hasError: boolean };

/** App-level boundary. On crash, offers a hard reset back to the welcome flow. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Hook point for Sentry.captureException — wired in a later pass.
    console.error('Kiosk crashed:', error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex h-full flex-col items-center justify-center gap-6 bg-cream px-10 text-center">
        <h1 className="text-3xl font-bold text-ink">{id.common.errorTitle}</h1>
        <p className="text-lg text-ink-muted">{id.common.errorBody}</p>
        <Button onClick={() => (window.location.href = '/')}>{id.instructions.newTransaction}</Button>
      </div>
    );
  }
}
